module.exports = __webpack_public_path__ + "static/media/BbBv2_20191010_1328041544989511.6e0aae58.jpg";